import React, { useState, useContext } from "react";
import styled from "styled-components";
import { GiRugbyConversion, GiSoccerBall } from "react-icons/gi";
import { IoIosArrowDown } from "react-icons/io";
import { GraphicsContext } from "../../contexts/GraphicsContext";
import { ScrollBar } from "../../Theme/Hyper";
import { APIContext } from "../../contexts/APIContext";
import { UIContext } from "../../contexts/UIContext";

const Main = styled(ScrollBar)`
  display: flex;
  width: 45%;
  flex-direction: column;
  max-height: 70vh;
`;
const Team = styled.div`
  /* height: 90%; */
`;
const Row = styled.div`
  display: flex;
  width: 100%;
  padding-right: 0.5em;
  font-size: 10px;
  font-weight: 100;
  align-items: center;
  box-sizing: border-box;
  opacity: ${(props) => (props.sub ? "0.5" : "1")};
  background-color: ${(props) =>
    props.fade ? "#181d25" : props.selected ? "#db0a41" : "#202731"};
  border-bottom: 2px solid #181d25;
  cursor: ${(props) => (props.clickable ? "pointer" : "")};
`;
const ShirtNumber = styled.div`
  display: flex;
  justify-content: center;
  min-width: 40px;
  /* border-right: 1px solid #d6d6d6; */
  padding-left: 0.5em;
`;

const Name = styled.div`
  /* min-width: 300px; */
  display: flex;
  padding: 0.5em;
  width: 100%;
  white-space: nowrap;
  color: ${(props) =>
    props.fade ? "#181d25" : props.selected ? "#fff" : "#fff"};

  background-color: ${(props) =>
    props.fade ? "#181d25" : props.selected ? "#db0a41" : "#202731"};
  :hover {
    color: ${(props) =>
      props.fade ? "#181d25" : props.selected ? "#fff" : "#d11e42"};
  }
`;
const FirstName = styled.div`
  display: flex;
  /* min-width: 200px; */
  /* border-right: 1px solid #d6d6d6; */
  padding-left: 0.5em;
`;
const LastName = styled.div`
  font-weight: 500;
  display: flex;
  /* min-width: 200px; */
  /* border-right: 1px solid #d6d6d6; */
  padding-left: ${(props) => (props.padLeft ? "0.5em" : "")};
`;
const Button = styled.div`
  display: flex;
  align-items: center;
  background-color: #181d25;
  box-sizing: border-box;
  border-radius: 4px;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  flex-grow: 1;
  padding: 3px;

  :hover {
    background-color: #db0a41;
    color: #fff;
  }
`;

const TooltipText = styled.span`
  visibility: hidden;
  width: 120px;
  background-color: #202731;
  color: #fff;
  text-align: center;
  padding: 5px 0;
  border-radius: 6px;

  /* Position the tooltip text - see examples below! */
  position: absolute;
  z-index: 10000;
  bottom: 150%;
  left: 50%;
  margin-left: -60px;
  opacity: 0;
  transition: opacity 0.2s ease-in-out;
`;

const Tooltip = styled.div`
  position: relative;
  display: inline-block;
`;

const Stat = styled.div`
  min-width: 45px;
  display: flex;
  justify-content: center;
  background-color: ${(props) => (props.selected ? "#d11e42" : "")};
  :hover {
    color: ${(props) =>
      props.fade ? "#181d25" : props.selected ? "#fff" : "#d11e42"};
  }
  :hover ${TooltipText} {
    visibility: visible;
    opacity: 1;
  }
`;

const POSITIONS = {
  "Goal Shooter": "GS",
  "Goal Attack": "GA",
  "Wing Attack": "WA",
  Centre: "C",
  "Wing Defence": "WD",
  "Goal Defence": "GD",
  "Goal Keeper": "GK",
};

const POSITIONS_SORT = {
  "Goal Shooter": 7,
  "Goal Attack": 6,
  "Wing Attack": 5,
  Centre: 4,
  "Wing Defence": 3,
  "Goal Defence": 2,
  "Goal Keeper": 1,
};

const CATEGORIES = {
  goals: "Goals",
  missed_shots: "Missed shots",
  penalties: "Penalties",
  rebounds_offensive: "Offensive rebounds",
  rebounds_defensive: "Defensive rebounds",
  intercepts: "Intercepts",
  deflections: "Deflections",
  turnovers: "Turnovers",
  unforced_errors: "Unforced errors",
};

export default function LineupStream({
  team,
  lineup,
  player_stats,
  selectPlayer,
  selectedPlayer,
  game,
  isFruit,
  manager,
}) {
  const { updateGame } = useContext(APIContext);
  const { homeKit, awayKit } = useContext(UIContext);
  const { previewGraphic } = useContext(GraphicsContext);
  const [selectedStats, setSelectedStats] = useState([]);
  let team_type = team._id === game.home_team._id ? "home" : "away";

  function toggleStat({ player, cat }) {
    if (selectedStats.indexOf(player._id + "." + cat) > -1) {
      setSelectedStats([
        ...selectedStats.filter((s) => s !== player._id + "." + cat),
      ]);
    } else {
      setSelectedStats([...selectedStats, player._id + "." + cat]);
    }
  }

  return (
    <Main>
      <Team>
        <Row style={{ fontSize: "11px", backgroundColor: "rgba(0,0,0,0)" }}>
          <ShirtNumber></ShirtNumber>
          <Name style={{ backgroundColor: "rgba(0,0,0,0)" }}></Name>
        </Row>

        {[
          ...lineup
            ?.filter((p) => p.order <= 7)
            ?.sort((a, b) => {
              let stat_a = player_stats?.find(
                (p) => p.squad_id === a?.squad?._id
              );
              let stat_b = player_stats?.find(
                (p) => p.squad_id === b?.squad?._id
              );
              return (
                POSITIONS_SORT[stat_a?.position] -
                POSITIONS_SORT[stat_b?.position]
              );
            }),
          ...lineup?.filter((p) => p.order > 7),
        ].map((item, index) => {
          let l = item;

          let player = {
            _id: l?.squad?._id,
            ...l?.squad?.player,
            order: l?.order,
            shirt_number: l?.squad?.shirt_number || l?.squad?.opta_shirt_number,
            squad: l?.squad,
            yellow_card: l?.yellow_card,
            dbl_yellow_card: l?.dbl_yellow_card,
            red_card: l?.red_card,
            sub_order: l?.sub_order,
            subbed: l?.subbed,
            captain: l?.captain,
            stats: player_stats?.find((p) => p.squad_id === l?.squad?._id),
          };
          return (
            <>
              {index === 7 && (
                <Row fade noHover key={index}>
                  <ShirtNumber></ShirtNumber>
                  <Name fade>
                    <FirstName></FirstName>
                  </Name>
                </Row>
              )}
              <Row
                key={l?.squad?._id}
                clickable
                sub={!player?.squad || player?.order > 7}
              >
                <ShirtNumber>{POSITIONS[player?.stats?.position]}</ShirtNumber>
                {/* <BeenSubbed>
                    {player?.subbed && player?.order <= 7 && <On />}
                    {player?.subbed && player?.order > 7 && <Off />}
                  </BeenSubbed> */}
                <Name
                  selected={
                    selectedPlayer?._id && selectedPlayer?._id === player._id
                  }
                  onClick={() => {
                    if (!selectedPlayer || selectedPlayer._id !== player._id) {
                      selectPlayer(player);
                    } else {
                      selectPlayer(null);
                    }
                  }}
                >
                  <FirstName>{player?.first_name}</FirstName>
                  <LastName padLeft={player?.first_name}>
                    {player?.last_name}
                    {player && player.captain && "(C)"}
                    <span
                      style={{
                        fontSize: ".7em",
                        fontWeight: "100",
                        alignSelf: "flex-end",
                        marginLeft: ".5em",
                      }}
                    >
                      {player && player.nationality && player.nationality.code}
                    </span>
                  </LastName>
                </Name>
              </Row>
            </>
          );
        })}
      </Team>
      <Row fade noHover>
        <ShirtNumber></ShirtNumber>
        <Name fade>
          <FirstName></FirstName>
        </Name>
      </Row>
      <Row noHover>
        <ShirtNumber></ShirtNumber>
        <Name
          selected={
            selectedPlayer?._id && selectedPlayer?._id === manager?.player?._id
          }
          onClick={() => {
            if (
              !selectedPlayer ||
              selectedPlayer._id !== manager?.player?._id
            ) {
              selectPlayer(manager?.player);
            } else {
              selectPlayer(null);
            }
          }}
        >
          {manager?.player?.title}
          <FirstName>{manager?.player?.first_name}</FirstName>
          <LastName padLeft={manager?.player?.first_name}>
            {manager?.player?.last_name}
          </LastName>
        </Name>
      </Row>
    </Main>
  );
}
